import React from 'react';
import PropTypes from 'prop-types';
import { EVButton, EVLink } from '@eagleview/ev-comp-library';
import getSafeHttpUrl from '../../utils/url.utils';

function readPartnerUrlFromLocation() {
  return new URLSearchParams(window.location.search).get('partner_url');
}

/**
 * Continue control for partner redirect. Uses onClick navigation (not href) so static
 * analysis does not treat query-string input as an unsanitized DOM href (DOM XSS).
 * Destination is still restricted to http(s) via getSafeHttpUrl.
 */
const PartnerContinueButton = ({ id, className }) => {
  const safeHref = getSafeHttpUrl(readPartnerUrlFromLocation());

  if (!safeHref) {
    return (
      <EVButton id={id} className={className} disabled>
        Continue authorization
      </EVButton>
    );
  }

  const goToPartner = (event) => {
    event.preventDefault();
    window.location.assign(safeHref);
  };

  return (
    <EVButton
      id={id}
      component={EVLink}
      className={className}
      onClick={goToPartner}
    >
      Continue authorization
    </EVButton>
  );
};

PartnerContinueButton.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PartnerContinueButton.defaultProps = {
  className: undefined,
};

export default PartnerContinueButton;
